import {
  Briefcase,
  CalendarDays,
  Contact,
  DatabaseBackup,
  FileDown,
  FileText,
  FlaskConical,
  FolderTree,
  GitBranch,
  GraduationCap,
  History,
  Image,
  Inbox,
  Landmark,
  LayoutDashboard,
  LayoutPanelTop,
  Link2,
  ListTree,
  type LucideIcon,
  Megaphone,
  Newspaper,
  Phone,
  Settings,
  ShieldCheck,
  Signpost,
  SquareStack,
  Tags,
  User,
  UserCog,
  UsersRound,
  Wrench,
} from 'lucide-react';

/**
 * The glyph beside a navigation entry.
 *
 * An explicit table, for the reason `VocationalIcon` has one: the bundler can
 * only tree-shake what it can see. The difference is that these names come from
 * `navigation.ts` rather than from the database, so a missing one is a typo in
 * our own source — `NavIcon.test.tsx` fails the build instead of a fallback
 * quietly standing in.
 */
const ICONS: Record<string, LucideIcon> = {
  'layout-dashboard': LayoutDashboard,
  newspaper: Newspaper,
  'folder-tree': FolderTree,
  tags: Tags,
  megaphone: Megaphone,
  'calendar-days': CalendarDays,
  'users-round': UsersRound,
  'file-text': FileText,
  'layout-panel-top': LayoutPanelTop,
  'square-stack': SquareStack,
  landmark: Landmark,
  'git-branch': GitBranch,
  'graduation-cap': GraduationCap,
  contact: Contact,
  wrench: Wrench,
  phone: Phone,
  'file-down': FileDown,
  image: Image,
  'flask-conical': FlaskConical,
  briefcase: Briefcase,
  'list-tree': ListTree,
  link: Link2,
  settings: Settings,
  inbox: Inbox,
  signpost: Signpost,
  'user-cog': UserCog,
  'shield-check': ShieldCheck,
  history: History,
  'database-backup': DatabaseBackup,
  user: User,
};

export interface NavIconProps {
  name: string;
  size?: number;
  className?: string;
}

export function NavIcon({ name, size = 18, className }: NavIconProps) {
  const Glyph = ICONS[name] ?? LayoutDashboard;

  // Decorative: the label sits beside it in the sidebar and in the palette.
  return <Glyph size={size} strokeWidth={1.75} aria-hidden="true" className={className} />;
}
